import React from 'react'

import { useUser } from '@/widgets/user'

import { useCart } from '@/entities/cart'
import { UserType } from '@/entities/user'

import { RadioOption } from '@/shared/types/radio-option'
import { Radio } from '@/shared/ui/radio'

import cl from './user-types.module.scss'

/**
 * List of user types
 */
const options: RadioOption<UserType>[] = [
	{
		label: `Физическое лицо`,
		value: UserType.Individual
	},
	{
		label: `Юридическое лицо`,
		value: UserType.JuridicalPerson
	}
]

/**
 * Chose user type
 */
export const UserTypes = (): JSX.Element => {
	const { changeUserType, isJuridicalUser } = useUser()
	const { getCartInfoWithEvents } = useCart()

	const currentValue = isJuridicalUser ? UserType.JuridicalPerson : UserType.Individual

	const handleChange = (e: { target: { value: string } }) => {
		const value = e.target.value as UserType
		changeUserType(value, `.iport.ru`)
		getCartInfoWithEvents()
	}

	return (
		<div className={cl.userTypes}>
			<Radio.Group value={currentValue} onChange={handleChange} buttonStyle="solid" className={cl.radioGroup}>
				{options.map(option => (
					<Radio.Button key={option.value} value={option.value} className={cl.radioButton}>
						{option.label}
					</Radio.Button>
				))}
			</Radio.Group>
		</div>
	)
}
